import { render, staticRenderFns } from "./LessonCalendarDialog.vue?vue&type=template&id=a83320f6&"
import script from "./LessonCalendarDialog.vue?vue&type=script&lang=ts&"
export * from "./LessonCalendarDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports